var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"user-wrapper"},[_c('keep-alive',[_c('router-view')],1),_c('menu-bar',{class:{'no-nav': _vm.$route.meta.userNav===false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }